import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/style/common.scss'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import { formatNumber } from "@/utils/common";
Vue.prototype.$FormatNumber = formatNumber;


Vue.config.productionTip = false

Vue.prototype.$withdrawLevelList = [
  { payInTotal: 0, number: 10, limit: 100000 },
  { payInTotal: 20, number: 10, limit: 100000 },
  { payInTotal: 100, number: 10, limit: 100000 },
  { payInTotal: 300, number: 10, limit: 100000 },
  { payInTotal: 800, number: 10, limit: 100000 },
  { payInTotal: 2000, number: 10, limit: 100000 },
  { payInTotal: 7000, number: 10, limit: 500000 },
  { payInTotal: 20000, number: 10, limit: 500000 },
  { payInTotal: 50000, number: 10, limit: 500000 },
];

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    if (location.search) this.$store.commit('SETSEARCHPARAMS', location.search);
    this.setFontSize();
  },
  mounted() {
    window.addEventListener('resize', this.setFontSize);
  },
  methods: {
    // 计算根元素 FontSize，设置 rem
    setFontSize () {
      document.documentElement.style.fontSize = `${document.documentElement.clientWidth / 24}px`;
    }
  },
}).$mount('#app')
